import { countryGetById } from '@studyportals/static-domain-data/countries/country-get-by-id';
import { countryGetDemonym } from '@studyportals/static-domain-data/countries/country-get-demonym';
import { countryGetIsoCode } from '@studyportals/static-domain-data/countries/country-get-iso-code';
import { countryGetPath } from '@studyportals/static-domain-data/countries/country-get-path';

export class Country {
	public readonly id: string;
	public readonly name: string;
	public readonly iso: string | null;
	public readonly demonym: string | null;
	public readonly path: string | null;

	public constructor(id: string) {
		const source = countryGetById(id);

		this.id = id;
		this.name = source?.name ?? 'Unknown';

		this.iso = countryGetIsoCode(id) ?? null;
		this.demonym = countryGetDemonym(id) ?? null;
		this.path = countryGetPath(id) ?? null;
	}
}
